import {
  getPrintAssignmentLink,
  getAssignmentsListPageLink,
  getAssignmentLink,
} from "@/assignments/utils/assignmentUtils";
import { Assignment } from "@/types/models/Assignment.interface";
import { ContentLevel } from "@/types/models/Content.interface";
import { UserProperties } from "@/types/models/UserProperties.interface";
import shouldDisableArticlePrint from "@/view/utils/shouldDisableArticlePrint";

interface ShareModalProps {
  content: {
    id: string;
    is_lite: boolean;
  };
  currentLevel?: ContentLevel;
  updatedAssignment: Assignment;
  userProperties: UserProperties;
}

export const getShareModalValues = ({
  content,
  currentLevel,
  updatedAssignment,
  userProperties,
}: ShareModalProps) => {
  const printLink = getPrintAssignmentLink(
    updatedAssignment.content_id,
    currentLevel?.id,
  );
  const allAssignmentsLink = getAssignmentsListPageLink();
  const assignmentLink = getAssignmentLink(
    updatedAssignment.assignment_id,
    content?.id,
  );
  const isPrintDisabled = shouldDisableArticlePrint(
    userProperties,
    content.is_lite,
  );

  return {
    allAssignmentsLink,
    assignmentLink,
    isPrintDisabled,
    printLink,
  };
};
